export interface StorageAdapter {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

const noopStorage: Storage = {
  get length() {
    return 0;
  },
  clear() {},
  getItem() {
    return null;
  },
  key() {
    return null;
  },
  removeItem() {},
  setItem() {},
};

export function getSafeLocalStorage(): Storage {
  if (typeof window === "undefined") {
    return noopStorage;
  }
  return window.localStorage;
}

export const localStorageAdapter: StorageAdapter = {
  getItem(key) {
    return getSafeLocalStorage().getItem(key);
  },
  setItem(key, value) {
    getSafeLocalStorage().setItem(key, value);
  },
  removeItem(key) {
    getSafeLocalStorage().removeItem(key);
  },
};

export function createNamespacedKey(prefix: string, suffix: string): string {
  return `${prefix}-${suffix}`;
}

export function createJsonStorageAdapter(storage: StorageAdapter) {
  return {
    getJSON<T>(key: string): T | null {
      const raw = storage.getItem(key);
      if (!raw) return null;
      try {
        return JSON.parse(raw) as T;
      } catch {
        return null;
      }
    },
    setJSON(key: string, value: unknown): void {
      storage.setItem(key, JSON.stringify(value));
    },
    removeItem(key: string): void {
      storage.removeItem(key);
    },
  };
}
